//Please add the language resource
const item = {
  projectCode: 'projectCode',
  projectName: 'projectName',
  shipperCode: 'shipperCode',
  shipperName: 'shipperName',
  costCode: 'costCode',
  costName: 'costName',
  companyCode: 'companyCode',
  companyName: 'companyName',
  acitveOff: 'acitveOff',
  createTime: 'createTime',
  creator: 'creator',
  updateTime: 'updateTime',
  updater: 'updater',
  msg: {
    projectCode: '请输入项目代码',
    projectName: '请输入项目名称',
    shipperCode: '请选择所属货主',
    companyCode: '请选择所属机构',
    costCode: '请输入成本中心代码',
    costName: '请输入成本中心名称',
    acitveOff: '是否启用'
  }
};
export default item



// WEBPACK FOOTER //
// ./src/page/mdm/item/lang/item.en.js